module.exports = __webpack_public_path__ + "img/clouds.d6d0de07.jpg";